import Image from 'next/image';

import { SUPPORTED_CHAIN_IDS } from '@/constants/chain';

import { fontStyles } from '@/styles/typography';

import { ChevronDownSmallIcon } from '@/ui/Icons/ChevronDownSmallIcon';
import { ExternalLink } from '@/ui/Link/ExternalLink';

import { routes } from '@/utils/routes';

export function MarketingFeaturesSection({
  swapText = `Zero fee trades on 9+ million tokens across ${SUPPORTED_CHAIN_IDS.length} chains.`,
  limitOrdersText = 'Get the price you want. No surprises.',
  crossChainText = 'Trade seamlessly across chains.',
}) {
  return (
    <div className="flex flex-col gap-2 tablet:flex-row">
      <div className="bg-special-background-card flex justify-between items-center p-6 rounded-lg flex-1 tablet:flex-col-reverse tablet:items-start tablet:gap-6 desktop:flex-row desktop:items-center first:tablet:rounded-bl-2xl last:tablet:rounded-br-2xl">
        <div className="flex flex-col gap-4">
          <div className={fontStyles({ variant: 'H5', class: ['text-token-gray-800'] })}>
            <span className="text-token-gray-1600">Swap.</span> {swapText}
          </div>
          <ExternalLink href={routes.SWAP_TOKENS}>
            <div className="inline-flex items-center justify-center content-center border-none ease-in-out duration-[200ms] disabled:transform-none disabled:cursor-not-allowed active:outline-none active:scale-[0.98] px-3 h-9 w-fit font-body text-[14px] leading-[16px] font-medium rounded-2xl text-token-gray-1600 bg-token-gray-200 hover:bg-token-alphalight-300 active:bg-token-alphalight-400 focus-visible:bg-token-alphalight-200 focus-visible:outline-token-alphalight-500">
              Learn more <ChevronDownSmallIcon className="ml-2 rotate-[-90deg]" />
            </div>
          </ExternalLink>
        </div>
        <Image src="/images/new-landing/swap-mode.webp" alt="swap" width={118} height={118} />
      </div>

      <div className="bg-special-background-card flex justify-between items-center p-6 rounded-lg flex-1 tablet:flex-col-reverse tablet:items-start tablet:gap-6 desktop:flex-row desktop:items-center first:tablet:rounded-bl-2xl last:tablet:rounded-br-2xl">
        <div className="flex flex-col gap-4">
          <div className={fontStyles({ variant: 'H5', class: ['text-token-gray-800'] })}>
            <span className="text-token-gray-1600">Limit orders.</span> {limitOrdersText}
          </div>
          <ExternalLink href={routes.LIMIT_ORDERS}>
            <div className="inline-flex items-center justify-center content-center border-none ease-in-out duration-[200ms] disabled:transform-none disabled:cursor-not-allowed active:outline-none active:scale-[0.98] px-3 h-9 w-fit font-body text-[14px] leading-[16px] font-medium rounded-2xl text-token-gray-1600 bg-token-gray-200 hover:bg-token-alphalight-300 active:bg-token-alphalight-400 focus-visible:bg-token-alphalight-200 focus-visible:outline-token-alphalight-500">
              Learn more <ChevronDownSmallIcon className="ml-2 rotate-[-90deg]" />
            </div>
          </ExternalLink>
        </div>
        <Image
          src="/images/new-landing/limit-mode.webp"
          alt="limit orders"
          width={118}
          height={118}
        />
      </div>

      <div className="bg-special-background-card flex justify-between items-center p-6 rounded-lg flex-1 tablet:flex-col-reverse tablet:items-start tablet:gap-6 desktop:flex-row desktop:items-center first:tablet:rounded-bl-2xl last:tablet:rounded-br-2xl">
        <div className="flex flex-col gap-4">
          <div className={fontStyles({ variant: 'H5', class: ['text-token-gray-800'] })}>
            <span className="text-token-gray-1600">Cross chain swaps.</span> {crossChainText}
          </div>
          <ExternalLink href={routes.CROSS_CHAIN_SWAPS}>
            <div className="inline-flex items-center justify-center content-center border-none ease-in-out duration-[200ms] disabled:transform-none disabled:cursor-not-allowed active:outline-none active:scale-[0.98] px-3 h-9 w-fit font-body text-[14px] leading-[16px] font-medium rounded-2xl text-token-gray-1600 bg-token-gray-200 hover:bg-token-alphalight-300 active:bg-token-alphalight-400 focus-visible:bg-token-alphalight-200 focus-visible:outline-token-alphalight-500">
              Learn more <ChevronDownSmallIcon className="ml-2 rotate-[-90deg]" />
            </div>
          </ExternalLink>
        </div>
        <Image
          src="/images/new-landing/cross-chain-mode.webp"
          alt="cross chain swaps"
          width={118}
          height={118}
        />
      </div>
    </div>
  );
}
